import { lazy } from 'react';

const EditReimbursements = lazy(() => import('./edit'));
const CreateReimbursements = lazy(() => import('./create'));

export { EditReimbursements, CreateReimbursements };
